import { Injectable } from '@angular/core';
import { AppState } from '@cpd-app/state';
import { Store } from '@ngrx/store';
import { clearPathway, getPathway } from './pathway.actions';
import {
  pathwayIdSelector,
  pathwayLoadingSelector,
  pathwaySelector
} from './pathway.selectors';

@Injectable({ providedIn: 'root' })
export class PathwayFacade {
  public pathway$ = this.store.select(pathwaySelector);
  public loading$ = this.store.select(pathwayLoadingSelector);
  public pathwayId$ = this.store.select(pathwayIdSelector);

  constructor(private store: Store<AppState>) {}

  public getPathway(pathwayId: string): void {
    this.store.dispatch(getPathway({ pathwayId }));
  }

  public clearPathway(): void {
    this.store.dispatch(clearPathway());
  }
}
